module.exports = __webpack_public_path__ + "img/play-video.9876ef4d.svg";